import ReactGA from 'react-ga'
import {getTrackingId} from 'helpers/tracking/index'
import {developmentMatch, localMatch, productionMatch} from 'helpers/tracking/matches'

const productionId = 'UA-143090609-1'
const developmentId = 'UA-143090609-2'
const defaultTrackingId = developmentId

export const trackingIds = [
  {
    match: productionMatch,
    id: productionId,
  },
  {
    match: developmentMatch,
    id: developmentId,
  },
  {
    match: localMatch,
    id: developmentId,
  },
]

export const initialise = () => {
  const trackingId = getTrackingId(trackingIds, defaultTrackingId)
  ReactGA.initialize(trackingId)
}

export const trackPage = (path) => {
  ReactGA.pageview(path, undefined, 'Clarity Go')
}

export const trackEvent = (category, action, label) => {
  ReactGA.event({category, action, label})
}